import { Container } from '@outdoorsyco/bonfire';
import React from 'react';

import PhotoGallery from '@/components/ui/PhotoGallery/PhotoGallery';
import { IImage } from '@/services/types/search/rentals/id';
import { IBreadcrumb } from '@/utility/commonDataTypes';

import { ActionsBar } from './ActionsBar';

type TPageHeroProps = {
  title: string;
  description: string;
  breadcrumbs?: IBreadcrumb[];
  images: IImage[];
  isClaimed?: boolean;
};

export const PageHero = ({
  title,
  description,
  breadcrumbs,
  images,
  isClaimed,
}: TPageHeroProps) => {
  return (
    <Container xsGutters={0} className="max-w-xxxl">
      <div className="relative h-80 md:h-120">
        <PhotoGallery images={images.slice(0, 4)} isSimple={!isClaimed} />

        <ActionsBar
          title={title}
          description={description}
          backUrl={breadcrumbs?.slice(0, 3).pop()?.url || '/'}
          photoCount={images.length}
          isClaimed={isClaimed}
        />
      </div>
    </Container>
  );
};
